"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * @phrospr/backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.6.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseIPlanningItemSearchEntity = void 0;
const iplanning_item_search_entity_sort_1 = require("./iplanning-item-search-entity-sort");
const iplanning_item_search_filter_entity_1 = require("./iplanning-item-search-filter-entity");
const iplanning_item_search_show_entity_1 = require("./iplanning-item-search-show-entity");
function parseIPlanningItemSearchEntity(data) {
    if (data.sort !== null && typeof data.sort === 'object')
        data.sort = (0, iplanning_item_search_entity_sort_1.parseIPlanningItemSearchEntitySort)(data.sort);
    if (data.filter !== null && typeof data.filter === 'object')
        data.filter = (0, iplanning_item_search_filter_entity_1.parseIPlanningItemSearchFilterEntity)(data.filter);
    if (data.show !== null && typeof data.show === 'object')
        data.show = (0, iplanning_item_search_show_entity_1.parseIPlanningItemSearchShowEntity)(data.show);
    return data;
}
exports.parseIPlanningItemSearchEntity = parseIPlanningItemSearchEntity;
